import constants from "../constants";

export function getHeaderContents(config) {
  return {
    search: {placeholderLabel: "layout.header.search.placeholder"},
    appSwitcherLinks: [
      {
        name: "account",
        label: "header.app-switcher.account.name",
        target: config.links.account.target,
        internal: config.links.account.internal,
        onClick: config.links.account.onClick
      },
      ...(config.links.directory
        ? [
            {
              name: "directory",
              label: "header.app-switcher.directory.name",
              target: config.links.directory.target,
              internal: config.links.directory.internal,
              onClick: config.links.directory.onClick
            }
          ]
        : []),
      ...(config.links.agenda
        ? [
            {
              name: "agenda",
              label: "header.app-switcher.agenda.name",
              target: config.links.agenda.target,
              internal: config.links.agenda.internal,
              onClick: config.links.agenda.onClick
            }
          ]
        : []),
      {
        name: "referenceGallery",
        label: "header.app-switcher.reference-gallery.name",
        target: config.links.referenceGallery.target,
        internal: config.links.referenceGallery.internal,
        onClick: config.links.referenceGallery.onClick
      },
      {
        name: "jobs",
        label: "header.app-switcher.jobs.name",
        target: config.links.jobs.target,
        internal: config.links.jobs.internal,
        onClick: config.links.jobs.onClick
      },
      ...(config.links.wizard
        ? [
            {
              name: "wizard",
              label: "header.app-switcher.wizard.name",
              target: config.links.wizard.target,
              internal: config.links.wizard.internal,
              onClick: config.links.wizard.onClick
            }
          ]
        : []),
      ...(config.links.catalog
        ? [
            {
              name: "catalog",
              target: config.links.catalog.target,
              internal: config.links.catalog.internal,
              label: "header.app-switcher.catalog.name",
              onClick: config.links.catalog.onClick
            }
          ]
        : []),
      ...(config.links.cloud
        ? [
            {
              name: "cloud",
              target: config.links.cloud.target,
              label: "header.app-switcher.cloud.name"
            }
          ]
        : []),
      ...(config.links.benchmarking
        ? [
            {
              name: "benchmarking",
              label: "header.app-switcher.benchmarking.name",
              target: config.links.benchmarking.target,
              internal: config.links.benchmarking.internal,
              onClick: config.links.benchmarking.onClick
            }
          ]
        : []),
      {
        name: "shop",
        target: "shop.sia-shop.url",
        label: "header.app-switcher.shop.name"
      },
      ...(config.links.valueApp
        ? [
            {
              name: "valueApp",
              label: "header.app-switcher.value-app.name",
              target: config.links.valueApp.target,
              internal: config.links.valueApp.internal,
              onClick: config.links.valueApp.onClick
            }
          ]
        : []),
      {
        name: "term",
        target: "term.url",
        label: "header.app-switcher.term.name"
      },
      {
        name: "ecom",
        target: "https://ecom.sia.ch",
        label: "header.app-switcher.ecom.name"
      }
    ]
  };
}

export function getFooterContents(config) {
  return {
    follow: {
      title: "layout.footer.follow.follow-us",
      newsletterButton: {
        target: "layout.footer.follow.newsletter-url",
        label: "layout.footer.follow.newsletter-subscription"
      },
      social: {
        facebook: constants.SIA_FACEBOOK,
        linkedIn: constants.SIA_LINKEDIN,
        twitter: constants.SIA_TWITTER,
        youTube: constants.SIA_YOUTUBE
      }
    },
    contactUs: {
      title: "layout.footer.contact.contact-us",
      buttons: [
        {
          target: config.contactUs
            ? config.contactUs.target
            : "layout.footer.contact.contact-url",
          label: "layout.footer.contact.contact"
        }
      ]
    },
    links: [
      {
        target: config.links.media
          ? config.links.media.target
          : "layout.footer.links.media-url",
        label: "layout.footer.links.media"
      },
      {
        target: config.links.newsletter
          ? config.links.newsletter.target
          : "layout.footer.links.newsletter-url",
        label: "layout.footer.links.newsletter"
      },
      {
        target: config.links.vacancies
          ? config.links.vacancies.target
          : "layout.footer.links.vacancies-url",
        label: "layout.footer.links.vacancies"
      },
      {
        target: config.links.privacyPolicy.target,
        label: "layout.footer.links.privacy-policy",
        internal: config.links.privacyPolicy.internal
      }
    ],
    about: {
      multilanguageSlogan: constants.MULTI_LANGUAGE_SLOGAN,
      phone: constants.SIA_PHONE_NUMBER,
      street: constants.SIA_STREET,
      zip: constants.SIA_ZIP,
      cityLabel: "layout.footer.address.city"
    }
  };
}

export function getOrgaFooterContents(config) {
  return {
    follow: {
      title: "layout.footer.follow.follow-us",
      newsletterButton: {
        target: "layout.footer.follow.newsletter-url",
        label: "layout.footer.follow.newsletter-subscription"
      },
      social: {
        facebook: constants.SIA_FACEBOOK,
        linkedIn: constants.SIA_LINKEDIN,
        twitter: constants.SIA_TWITTER,
        youTube: constants.SIA_YOUTUBE
      }
    },
    contactUs: {
      title: "layout.footer.contact.contact-us",
      buttons: [
        {
          target: config.contactUs
            ? config.contactUs.target
            : "layout.footer.contact.contact-url",
          label: "layout.footer.contact.contact"
        }
      ]
    },
    links: [
      {
        target: config.links.media
          ? config.links.media.target
          : "layout.footer.links.media-url",
        label: "layout.footer.links.media"
      },
      {
        target: config.links.newsletter
          ? config.links.newsletter.target
          : "layout.footer.links.newsletter-url",
        label: "layout.footer.links.newsletter"
      },
      {
        target: config.links.vacancies
          ? config.links.vacancies.target
          : "layout.footer.links.vacancies-url",
        label: "layout.footer.links.vacancies"
      },
      {
        target: config.links.privacyPolicy.target,
        label: "layout.footer.links.privacy-policy.orga",
        internal: config.links.privacyPolicy.internal
      }
    ],
    about: {
      multilanguageSlogan: constants.MULTI_LANGUAGE_SLOGAN,
      phone: constants.SIA_PHONE_NUMBER,
      street: constants.SIA_STREET,
      zip: constants.SIA_ZIP,
      cityLabel: "layout.footer.address.city"
    }
  };
}

export function getBMFooterContents(config) {
  return {
    follow: {
      title: "layout.footer.follow.follow-us",
      social: {
        facebook: constants.SIA_FACEBOOK,
        linkedIn: constants.SIA_LINKEDIN,
        twitter: constants.SIA_TWITTER,
        youTube: constants.SIA_YOUTUBE
      }
    },
    contactUs: {
      title: "layout.footer.contact.contact-us",
      buttons: [
        {
          target: config.contact.target,
          label: "layout.footer.contact.contact"
        }
      ]
    },
    links: [
      {
        target: config.links.termsAndConditions.target,
        label: "layout.footer.links.terms-and-conditions"
      },
      {
        target: config.links.privacyPolicy.target,
        label: "layout.footer.links.privacy-policy"
        // internal: config.links.privacyPolicy.internal,
      },
      {
        target: config.links.help.target,
        label: "layout.footer.links.faq"
        // internal: config.links.help.internal,
      }
    ],
    about: {
      multilanguageSlogan: constants.MULTI_LANGUAGE_SLOGAN,
      phone: constants.SIA_PHONE_NUMBER,
      street: constants.SIA_STREET,
      zip: constants.SIA_ZIP,
      cityLabel: "layout.footer.address.city"
    }
  };
}
